import { render, staticRenderFns } from "./showMemberDetailStudent.vue?vue&type=template&id=2800ba79&lang=pug&"
import script from "./showMemberDetailStudent.vue?vue&type=script&lang=js&"
export * from "./showMemberDetailStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2800ba79')) {
      api.createRecord('2800ba79', component.options)
    } else {
      api.reload('2800ba79', component.options)
    }
    module.hot.accept("./showMemberDetailStudent.vue?vue&type=template&id=2800ba79&lang=pug&", function () {
      api.rerender('2800ba79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/components/account/showMemberDetailStudent.vue"
export default component.exports